import { BaseEnum } from "./baseEnum";

const listCompetenceTypeEnum: Array<CompetenceTypeEnum> = [];

export type CompetenceType = "Behavioral" | "Technical";

export class CompetenceTypeEnum extends BaseEnum {
	static Behavioral = new CompetenceTypeEnum(
		1,
		"Behavioral",
		"Comportamental",
		"user"
	);
	static Technical = new CompetenceTypeEnum(
		2,
		"Technical",
		"Técnico",
		"tools"
	);

	constructor(
		public id: number,
		public value: string,
		public label: string,
		icon: string
	) {
		super(id, value, label, icon);
		listCompetenceTypeEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listCompetenceTypeEnum;
	}
}